import { render, staticRenderFns } from "./Contactanos.vue?vue&type=template&id=cdaa8672&scoped=true"
import script from "./Contactanos.vue?vue&type=script&lang=js"
export * from "./Contactanos.vue?vue&type=script&lang=js"
import style0 from "./Contactanos.vue?vue&type=style&index=0&id=cdaa8672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaa8672",
  null
  
)

export default component.exports